import { getDatePillText } from '../FilterOptions'
import {
  AgGridFilterType,
  AgGridFilters,
  AgGridFiltersTypes,
  DateFilter,
  FilterChip,
  NumberFilter,
  SetFilter,
  TextFilter,
} from '../agGridFilters.types'

const isTextFilter = (filter: AgGridFiltersTypes): filter is TextFilter =>
  filter.filterType === AgGridFilterType.Text &&
  (filter as TextFilter).filter !== undefined

const isNumberFilter = (filter: AgGridFiltersTypes): filter is NumberFilter =>
  filter.filterType === AgGridFilterType.Number

const isDateFilter = (filter: AgGridFiltersTypes): filter is DateFilter =>
  filter.filterType === AgGridFilterType.Date

const isSetFilter = (filter: AgGridFiltersTypes): filter is SetFilter =>
  filter.filterType === AgGridFilterType.Set && filter.values !== undefined

export const getFilterChipValue = (filter: AgGridFiltersTypes): string => {
  if (isTextFilter(filter)) return filter.filter
  if (isNumberFilter(filter) && filter.currencySymbol) {
    return `${filter.filter}${filter.currencySymbol} - ${filter.filterTo}${filter.currencySymbol}`
  }
  if (isNumberFilter(filter) && !filter.currencySymbol) {
    return `${filter.filter} - ${filter.filterTo}`
  }
  if (isDateFilter(filter)) {
    return getDatePillText(filter)
  }

  return ''
}

export const getFilterChipLabel = (filter: FilterChip): string => {
  if (filter.filterType === AgGridFilterType.Date) {
    return `${filter.label}:`
  }
  return ''
}

export const removeFilter = (
  currentFilters: AgGridFilters<string>,
  name: string,
  value?: string,
): AgGridFilters<string> => {
  if (
    isSetFilter(currentFilters[name]) &&
    (currentFilters[name] as SetFilter).values.length > 1
  ) {
    const currentFilter = currentFilters[name] as SetFilter
    return {
      ...currentFilters,
      [name]: {
        ...currentFilter,
        values: currentFilter.values.filter((setValue) => setValue !== value),
      },
    }
  }

  const newFilters = { ...currentFilters }
  delete newFilters[name]
  return newFilters
}
